import React, { useEffect, useState } from "react";
import "../../../components/css/RequirementModel.css";
import { Auth } from "aws-amplify";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CREATE_REQUIREMENT,
  TEAM_MEMBERS_LIST,
} from "../../../lib/API_KEYS";
import { ApiHelper } from "../../../utils/ApiHelper";


export default function RequirementModal({ onClose, initialData }) {
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState([]);

  const [teamMembers, setTeamMembers] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(true);
  const [requirementId, setRequirementId] = useState(null);
  const [formData, setFormData] = useState({
    industry: "",
    service: "",
    title: "",
    description: "",
    quantity: "",
    material: "",
    quality: "",
    packaging: "",
    logistics: "",
    delivery: "",
    supplierLocation: "checked",
    type: "",
    team: []
  });


  useEffect(() => {
    const fetchTeamMembers = async () => {
      setLoadingMembers(true);
      try {
        const res = await new ApiHelper().FetchFromServer(...TEAM_MEMBERS_LIST);
        setTeamMembers(res.data || []);
      } catch (err) {
        console.error("Error fetching team members:", err);
        setTeamMembers([]);
      } finally {
        setLoadingMembers(false);
      }
    }

    fetchTeamMembers();
  }, []);

  useEffect(() => {
    if (initialData) {
      setFormData({
        industry: initialData.industry || "",
        service: initialData.service || "",
        title: initialData.title || "",
        description: initialData.description || "",
        quantity: initialData.quantity || "",
        material: initialData.material || "",
        quality: initialData.quality || "",
        packaging: initialData.packaging || "",
        logistics: initialData.logistics || "",
        delivery: initialData.delivery || "",
        supplierLocation: initialData.supplierLocation || "checked",
        type: initialData.type || "",
        team: initialData.team || []
      });
      setSelected(initialData.team || []);
    }
  }, [initialData]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const toggleMember = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const validateStep = () => {
    if (step === 1 && (!formData.industry || !formData.service)) {
      toast.error("Please fill all fields in Step 1");
      return false;
    }


    if (step === 2) {
      const requiredFields = ["title", "description", "quantity", "material", "quality", "packaging", "logistics", "delivery"];
      for (let field of requiredFields) {
        if (!formData[field]) {
          toast.error("Please fill all required fields in Step 2");
          return false;
        }
      }
    }


    if (step === 3 && !formData.type) {
      toast.error("Please select an option in Step 3");
      return false;
    }


    // if (step === 4 && selected.length === 0) {
    //   toast.error("Please select at least one team member in Step 4");
    //   return false;
    // }

    return true;
  };




  const nextStep = async () => {
    if (!validateStep()) return;

    if (step === 4) {
      setSubmitting(true);
      try {
        const payload = {
          ...formData,
          team: selected,
          status: "In Review"
        };

        const res = await new ApiHelper().FetchFromServer(
          ...CREATE_REQUIREMENT,
          undefined,
          payload
        );
        setRequirementId(res?.data?.requirementId || null);

        toast.success("Requirement posted successfully!");
        setStep(5);
      } catch (err) {
        console.error(err);
        toast.error("Failed to post requirement");
      } finally {
        setSubmitting(false);
      }
      return;
    }



    setStep(prev => Math.min(prev + 1, 5));
  };

  const prevStep = () => setStep(prev => Math.max(prev - 1, 1));

  return (

    <>

      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-container" onClick={(e) => e.stopPropagation()}>

          {step === 1 && (
            <div className="modal-content">
              <div className="p-4 w-100" style={{ maxWidth: "400px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-semibold mb-0">Create New Requirement</h5>
                  <span className="text-muted small">Step 1/4</span>
                </div>
                <div className="mb-3">
                  <label className="form-label">Industry <span style={{ color: "red" }}>*</span></label>
                  <select
                    name="industry"
                    className="form-select"
                    value={formData.industry}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>Select Industry</option>
                    <option>Aerospace</option>
                    <option>Automotive</option>
                    <option>Consumer Goods</option>
                    <option>Energy</option>
                    <option>Industrial Machinery</option>
                    <option>Electronics and Semiconductor</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label className="form-label">Service <span style={{ color: "red" }}>*</span></label>
                  <select
                    name="service"
                    className="form-select"
                    value={formData.service}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>Select Service</option>
                    <option>Design</option>
                    <option>Simulation</option>
                    <option>Manufacturing</option>
                    <option>CNC Machining</option>
                    <option>Precision Machining</option>
                    <option>Sheet Metal</option>
                    <option>Prototyping</option>
                    <option>Casting</option>
                    <option>Forging</option>
                    <option>Jigs and Fixtures</option>
                    <option>Aerospace Standard Parts</option>
                  </select>
                </div>
                <div className="d-flex justify-content-between">
                  <button className="btn btn-outline-secondary" onClick={onClose}>Cancel</button>
                  <button className="btn btn-dark" onClick={nextStep}>Continue</button>
                </div>
              </div>
            </div>
          )}


          {step === 2 && (
            <div className="modal-content">
              <div className="p-4 w-100" style={{ maxWidth: "520px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-semibold mb-0">Requirement Details</h5>
                  <span className="text-muted small">Step 2/4</span>
                </div>
                <div className="mb-3">
                  <label className="form-label">Requirement Title <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="title" className="form-control" placeholder="Title for Job Post" value={formData.title} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Brief Description <span style={{ color: "red" }}>*</span></label>
                  <textarea className="form-control" rows="2" name="description" placeholder="Brief Description for Project" value={formData.description} onChange={handleInputChange}></textarea>
                </div>
                <div className="mb-3">
                  <label className="form-label">Quantity Required <span style={{ color: "red" }}>*</span></label>
                  <input type="number" name="quantity" className="form-control" placeholder="Quantity Required" value={formData.quantity} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Material Specifications <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="material" className="form-control" placeholder="Material Specifications" value={formData.material} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Quality Specifications <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="quality" className="form-control" placeholder="Quality Specifications" value={formData.quality} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Packaging Specifications <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="packaging" className="form-control" placeholder="Packaging Specifications" value={formData.packaging} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Logistics Specifications <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="logistics" className="form-control" placeholder="Logistics Specifications" value={formData.logistics} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Delivery Timelines <span style={{ color: "red" }}>*</span></label>
                  <input type="text" name="delivery" className="form-control" placeholder="Delivery Timelines" value={formData.delivery} onChange={handleInputChange} />
                </div>
                <div className="mb-4">
                  <label className="form-label d-block">Preferred Supplier Location <span style={{ color: "red" }}>*</span></label>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="supplierLocation" value="Global" checked={formData.supplierLocation === "Global"} onChange={handleInputChange} />
                    <label className="form-check-label">Global</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="supplierLocation" value="USA" checked={formData.supplierLocation === "USA"} onChange={handleInputChange} />
                    <label className="form-check-label">USA</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="supplierLocation" value="India" checked={formData.supplierLocation === "India"} onChange={handleInputChange} />
                    <label className="form-check-label">India</label>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <button className="btn btn-outline-secondary" onClick={prevStep}>Back</button>
                  <button className="btn btn-dark" onClick={nextStep}>Continue</button>
                </div>
              </div>
            </div>
          )}


          {step === 3 && (
            <div className="modal-content">
              <div className="p-4 w-100" style={{ maxWidth: "520px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-semibold mb-0">Whom do you want to work with?</h5>
                  <span className="text-muted small">Step 3/4</span>
                </div>
                <div className="mb-3">
                  <label className="d-flex align-items-start w-100 option-label">
                    <input
                      className="form-check-input me-3 mt-2"
                      type="radio"
                      name="type"
                      value="public"
                      checked={formData.type === "public"}
                      onChange={handleInputChange}
                    />
                    <div className="option-card border rounded-3 p-3 w-100">
                      <div className="fw-semibold">Open For All</div>
                      <div className="text-muted small">Available to all manufacturers on the marketplace, collects the largest amount of offers</div>
                    </div>
                  </label>
                </div>

                <div className="mb-3">
                  <label className="d-flex align-items-start w-100 option-label">
                    <input
                      className="form-check-input me-3 mt-2"
                      type="radio"
                      name="type"
                      value="vetted"
                      checked={formData.type === "vetted"}
                      onChange={handleInputChange}
                    />
                    <div className="option-card border rounded-3 p-3 w-100">
                      <div className="fw-semibold">Cnerzy Recommended</div>
                      <div className="text-muted small">The matching system selects best manufacturers with experience and successfully completed projects in this niche</div>
                    </div>
                  </label>
                </div>

                <div className="mb-3">
                  <label className="d-flex align-items-start w-100 option-label">
                    <input
                      className="form-check-input me-3 mt-2"
                      type="radio"
                      name="type"
                      value="previous"
                      checked={formData.type === "previous"}
                      onChange={handleInputChange}
                    />
                    <div className="option-card border rounded-3 p-3 w-100">
                      <div className="fw-semibold">Previously Engaged Sellers</div>
                      <div className="text-muted small">This request will be available to selected contractors only who already provided you services</div>
                    </div>
                  </label>
                </div>
                <div className="d-flex justify-content-between">
                  <button className="btn btn-outline-secondary" onClick={prevStep}>Back</button>
                  <button className="btn btn-dark" onClick={nextStep}>Continue</button>
                </div>
              </div>
            </div>
          )}


          {step === 4 && (
            <div className="modal-content">
              <div className="p-4 w-100" style={{ maxWidth: "520px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-semibold mb-0">Add team members</h5>
                  <span className="text-muted small">Step 4/4</span>
                </div>

                {loadingMembers ? (
                  <p>Loading team members...</p>
                ) : !teamMembers.length ? (
                  <p>No team members found.</p>
                ) : (
                  teamMembers.map((member) => (
                    <div key={member._id} className="mb-1">
                      <label className="d-flex align-items-center w-100 option-member">
                        <input
                          type="checkbox"
                          className="form-check-input me-3 mt-0"
                          checked={selected.includes(member._id)}
                          onChange={() => toggleMember(member._id)}
                          data-team-id={member._id}
                        />
                        <div
                          className={`member-card d-flex align-items-center w-100 border-bottom py-3 ${selected.includes(member.id) ? "bg-light shadow-sm" : ""
                            }`}
                        >

                          {member.profilePic ? (
                            <img
                              src={member.profilePic}
                              alt={member.name}
                              className="rounded-circle me-3"
                              width="36"
                              height="36"
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center me-3"
                              style={{ width: 36, height: 36, fontWeight: "bold" }}
                            >
                              {member.name.charAt(0).toUpperCase()}
                            </div>
                          )}

                          <div className="flex-grow-1">
                            <div className="fw-semibold">{member.name}</div>
                            <div className="text-muted small">{member.role}</div>
                          </div>
                        </div>
                      </label>
                    </div>
                  ))
                )}

                <div className="d-flex justify-content-between mt-3">
                  <button className="btn btn-outline-secondary" onClick={prevStep}>
                    Back
                  </button>
                  <button className="btn btn-dark" onClick={nextStep}>
                    {submitting ? "Posting.." : "Post Requirement"}
                  </button>
                </div>
              </div>
            </div>
          )}



          {step === 5 && (
            <div
              className="modal-content d-flex flex-column align-items-center text-center w-100 mx-auto"
              style={{
                width: "95%",
                maxWidth: "1200px",
                padding: "40px 30px",
                borderRadius: "12px"
              }}
            >
              <img
                src="/images/dashboardRightSide.svg"
                alt="Success"
                className="img-fluid mb-4"
                style={{ maxWidth: "160px" }}
              />
              <h2 className="mb-3">🎉 Thank You!</h2>
              <p className="mb-4 text-muted" style={{ fontSize: "16px", lineHeight: "1.5" }}>
                You’ve successfully posted your requirement <span className="text-dark">{requirementId}</span>. Cnerzy will be reviewing your requirement in 1-2 days.
              </p>
              <button onClick={onClose} className="btn btn-dark px-4">
                Close
              </button>
            </div>
          )}

        </div>
      </div>
      <ToastContainer />
    </>

  );
}
